import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import 'jquery'
import "@popperjs/core"
import 'bootstrap'

Rails.start()
Turbolinks.start()
ActiveStorage.start()
